import styled from 'styled-components';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { MiddleText } from '../styles/common.styles';

export const W3WText = styled(MiddleText).attrs({
  width: '100%',
  ellipsis: true,
})`
  @media (max-width: ${BP_LAPTOP}px) {
    ${({ isHistoricLocation }) =>
      isHistoricLocation ? 'width: 110px' : 'width: 100%'}
  }
`;
